<template>
  <VueDragResize
    :z="10001"
    :w="900"
    :h="600"
    :minw="400"
    :minh="600"
    :x="200"
    :y="50"
    :isResizable="false"
    :parentLimitation="true"
    contentClass="box-shaddow"
    v-show="visible"
  >
    <FullScreen :fullscreen.sync="fullscreen" style="height: 100%; width: 100%">
      <div class="sipContainer" :style="mainStyle">
        <div class="fullscreen-btn" @click="fullscreen = !fullscreen">
          <i
            :class="[
              'iconfont',
              fullscreen ? 'icon-tuichuquanping' : 'icon-shuyi_quanping',
            ]"
            :title="fullscreen ? '退出全屏' : '全屏'"
          ></i>
        </div>
        <div class="videoViewer" :class="isVideoCall ? 'visibleView' : ''">
          <video
            ref="remoteWin"
            class="remote"
            :class="traggle ? 'subWin' : ''"
          ></video>
          <video
            ref="localWin"
            muted="muted"
            class="local"
            :class="!traggle ? 'subWin' : ''"
            @click="traggleHandler"
          ></video>
        </div>

        <div class="sipUserIcon" v-if="!calling">
          <img @error="setDefaultPng($event)" :src="userIcon" />
        </div>

        <div class="sipCallStatus" v-if="calling && !endMessage">
          <img
            @error="setDefaultPng($event)"
            :src="userIcon"
            style="border-radius: 6px"
          />
          <div class="sipUserName">{{ userName }}</div>
        </div>

        <div class="sipEndMessage" v-if="endMessage">
          <span>{{ endMessage }}</span>
        </div>

        <div class="sipControl flex-center">
          <div
            v-if="income"
            @click="endSipCall('结束通话')"
            class="flex-center flex-column sip-btn"
          >
            <el-button icon="iconfont icon-handUp" circle type="danger">
            </el-button>
            <div class="sip-btn-label">拒绝</div>
          </div>
          <div
            v-if="income"
            @click="acceptIncome"
            class="flex-center flex-column sip-btn"
          >
            <el-button type="success" circle icon="iconfont icon-call">
              <!-- 接听 -->
            </el-button>
            <div class="sip-btn-label">接听</div>
          </div>
          <div v-if="callup" @click="endSipCall('取消通话')">
            <el-button
              icon="iconfont icon-handUp"
              circle
              type="danger"
            ></el-button>
            <div class="sip-btn-label">取消通话</div>
          </div>

          <div
            v-if="callend"
            @click="endSipCall('结束通话')"
            class="flex-center flex-column sip-btn"
          >
            <el-button icon="iconfont icon-handUp" circle type="danger">
            </el-button>
            <div class="sip-btn-label">结束通话</div>
          </div>
        </div>
        <audio
          src="@/assets/connect.mp3"
          ref="connectAudioTip"
          preload="true"
        ></audio>
      </div>
    </FullScreen>
  </VueDragResize>
</template>
<script>
import SIP from "@/assets/js/sip-0.7.8.js";
import userIcon from "@/assets/images/logo.png";
import GlobalConfig from "@/config/config";
// import {
//   getConfig,
//   getUserInfo,
//   selfInfo,
//   getAvatarUrl,
// } from "../../scripts/api";
import VueDragResize from "vue-drag-resize";
import { component as FullScreen } from "vue-fullscreen";
export default {
  name: "sip",
  props: {
    width: {
      type: [Number, String],
      default() {
        return "900px";
      },
    },
    height: {
      type: [Number, String],
      default() {
        return "600px";
      },
    },
  },
  components: {
    VueDragResize,
    FullScreen,
  },
  data() {
    return {
      visible: false,
      traggle: false,
      ua: null,
      sesstion: null,
      hangupFlag: false,
      userIcon: "",
      userName: "",
      income: false,
      callup: false,
      callend: false,
      callType: "",
      endMessage: "",
      calling: true,
      isVideoCall: false,
      $user: {},
      $config: GlobalConfig,
      fullscreen: false,
    };
  },
  computed: {
    mainStyle() {
      let width = this.$props.width;
      let height = this.$props.height;
      let sty = {
        // width,
        // height,
      };

      return sty;
    },
  },

  methods: {
    setDefaultPng(evt) {
      evt.target.src = userIcon;
    },
    uuid() {
      const chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      const uuid = [];
      for (let i = 0; i < 36; i++) {
        if (i == 14) {
          uuid[i] = "4";
        } else if (i == 8 || i == 13 || i == 18 || i == 23) {
          uuid[i] = "-";
        } else if (i == 19) {
          uuid[i] = chars.substr((uuid[i] & 0x3) | 0x8, 1);
        } else {
          uuid[i] = chars.substr(Math.floor(Math.random() * 0x3e), 1);
        }
      }

      return uuid.join("");
    },
    traggleHandler() {
      this.traggle = !this.traggle;
    },
    //播放连接提示声音
    playTip() {
      this.$refs.connectAudioTip.volume = 1;
      this.$refs.connectAudioTip.mounted = false;
      this.$refs.connectAudioTip.loop = true;
      this.$refs.connectAudioTip.play();
    },
    //结束连接提示声音
    endTip() {
      this.$refs.connectAudioTip.volume = 0;
      this.$refs.connectAudioTip.mounted = true;
      this.$refs.connectAudioTip.loop = false;
      this.$refs.connectAudioTip.pause();
    },
    /**
     * 连接注册
     */
    connectServer() {
      const self = this;
      console.log(this.$config);
      const sipServer = self.$config.sipServer;
      const sipWsServer = self.$config.sipWsServer;
      const sipPwd = self.$config.sipPwd || 1234;
      self.ua = new SIP.UA({
        uri: "1006" + "@" + sipServer,
        wsServers: [sipWsServer],
        password: sipPwd,
        traceSip: true,
        Number: 3,
        iceCheckingTimeout: 500,
      });
      console.log(self.ua);
    },
    /**
     * 通话类型
     * @method getMediaType
     * @param {String} str
     * @returns {Object}
     */
    getMediaType(str) {
      const rega = /m=audio+/g;
      const regv = /m=video+/g;
      let audio = false;
      let video = false;

      if (rega.exec(str)) {
        audio = true;
      }

      if (regv.exec(str)) {
        video = true;
      }

      return { audio: audio, video: video };
    },
    /**
     * 挂断,结束通话
     */
    handup() {
      const self = this;

      if (!self.hangupFlag) {
        self.hangupFlag = true;
        try {
          if (self.session) {
            if (self.session.startTime && !self.session.endTime) {
              self.session.bye();
            } else if (self.session.cancel) {
              self.session.cancel();
            } else {
              self.session.reject();
            }
          }
        } catch (e) {
          // console.info("handup: error", e);
        } finally {
          self.endTip();
          self.session = null;
          self.visible = false;
          self.hangupFlag = false;
          self.callType = "";
          self.endMessage = "";
          self.isVideoCall = false;
          // console.info("video call is handup ------------------------------");
        }
      }
    },
    /**
     * 接受打入
     */
    acceptIncome() {
      const constraints = {};
      constraints.audio = true;
      const self = this;

      if (this.callType == "video") {
        constraints.video = true;
        self.isVideoCall = true;
      } else {
        constraints.video = false;
        self.isVideoCall = false;
      }
      console.log(this.$refs.remoteWin);
      this.session.accept({
        media: {
          render: {
            remote: this.$refs.remoteWin,
            local: this.$refs.localWin,
          },
          constraints: constraints,
        },
      });
      setTimeout(() => {
        this.callend = false;
        this.income = false;
        this.callup = true;
        this.endTip();
      }, 50);
    },
    /**
     * 接通
     */
    acceptSipCall() {
      this.callend = true;
      this.income = false;
      this.callup = false;
      this.calling = false;
    },
    /**
     * 通话结束
     */
    endSipCall(msg) {
      const self = this;
      setTimeout(() => {
        self.endMessage = msg;
        self.showClass = "";
        self.videoClass = "";
        self.userClass = "";
        self.userIcon = "";
        self.userName = "";
        self.income = false;
        self.callup = false;
        self.callend = false;
      }, 50);
      setTimeout(function () {
        self.handup();
      }, 800);
    },
    /**
     * sesstion 事件监听
     */
    sessionEvent() {
      const self = this;

      self.session.on("accepted", function (data) {
        self.endTip();
        // console.info("---------------accept", data);
        self.acceptSipCall();
      });

      // 对方挂断
      self.session.on("cancel", function () {
        // console.info("---------User handup");
        // self.handup();
        self.endSipCall("对方已挂断");
      });

      // 无法接通
      self.session.on("failed", function (e) {
        self.endTip();
        // console.info("-------------failed:", e);
        // self.handup();
      });

      self.session.on("rejected", function (response, cause) {
        self.endTip();
        // console.info("rejected", response, cause);
        // self.handup();
        self.endSipCall("对方已挂断");
      });

      self.session.on("progress", function (response) {
        // console.info("-------------progress:", response);
      });

      self.session.on("bye", function () {
        console.log(8889999);
        self.endSipCall("通话结束");
        // self.handup();
      });
    },
    /**
     * 打出界面显示
     */
    inviteOutUI(info) {
      // this.userIcon = getAvatarUrl(info.userId);
      this.userIcon = "";
      this.userName = info.nickname;
      this.callend = false;
      this.income = false;
      this.callup = true;
      this.calling = true;
      this.visible = true;
    },
    //对外呼叫
    sipCall(msg) {
      const self = this;

      const constraints = {
        audio: true,
        video: true,
      };

      if (msg) {
        if (self.callType == "video") {
          constraints.video = true;
          self.isVideoCall = true;
        } else {
          constraints.video = false;
        }
        self.userName = msg.userName;

        self.inviteOutUI({ userId: msg.to, nickname: msg.userName });
        self.playTip();
        // const target = `sip:alice.${msg.to}@sipjs.onsip.com`
        //  self.session = self.ua.invite(target, {
        self.session = self.ua.invite(
          "sip:" + msg.to + "@" + self.$config.sipServer + ":5080",
          {
            media: {
              constraints: constraints,
              render: {
                remote: this.$refs.remoteWin,
                local: this.$refs.localWin,
              },
            },
          }
        );

        self.ua.on("message", function (message) {
          // console.info("sip message is come in ===========>>", message, this.income);
          // "%sip_ctl%,3fb3db41-c5cc-473e-9975-58489834b1ed,user_busy_now"
          const msg = message.body.split(",");
          if (msg[2] == "user_busy_now") {
            self.endTip();
            self.endSipCall("对方正忙，请稍后再试");
          }
        });

        self.sessionEvent();
      }
    },
    /**
     * 打进
     */
    incomeCall() {
      const self = this;

      // self.ua.message('bob@example.com','您好，鲍勃');
      self.ua.on("invite", function (session) {
        console.log("打进。。。。");
        console.log(session);
        if (!self.session) {
          console.log("=============打进");
          // self.playTip()
          const avtype = self.getMediaType(session.request.body);
          self.callType = avtype.audio && avtype.video ? "video" : "audio";
          self.session = session;
          self.sessionEvent();
          const usId = session.request.from.uri.user;
          self.inviteToUI({ nickname: usId });
          self.playTip();
        } else {
          const usId = session.request.from.uri.user;
          self.ua.message(
            usId + "@" + self.$config.sipServer,
            `%sip_ctl%,${self.uuid()},user_busy_now`
          );
        }
      });
    },
    /**
     * 拨打，打入界面处理
     */
    inviteToUI(info) {
      this.userIcon = "";
      this.userName = info.nickname;
      this.callend = false;
      this.income = true;
      this.callup = false;
      this.visible = true;
    },
    /**
     * 监听打出
     */
    callOut() {
      const self = this;
      this.$root.bus.$on("sipCall", (data) => {
        console.log(data);
        self.callType = data.callType;

        self.sipCall(data.user);
      });
    },
  },
  created() {
    // this.$user = getUserInfo();

    this.$config = GlobalConfig;
    this.$user = {};
  },
  mounted() {
    const self = this;
    this.connectServer();
    this.incomeCall();
    this.callOut();
  },
  watch: {
    visible(val) {},
  },
  destroyed() {
    this.$root.bus.$off("sipCall");
  },
};
</script>
<style lang="scss" scoped>
.box-shaddow {
  box-shadow: 0 4px 20px 0 rgba(0, 54, 128, 0.08);
}

.sipContainer {
  background-color: #222222;
  overflow: hidden;
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // z-index: 10001;
  // transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 20px 0 rgba(0, 54, 128, 0.08);
  .fullscreen-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    z-index: 1000;
    cursor: pointer;
    i {
      font-size: 30px;
    }
  }
  .videoViewer {
    width: 100%;
    height: 100%;
    position: relative;
    visibility: hidden;

    .remote,
    .local {
      width: 100%;
      height: 100%;
    }

    .subWin {
      height: 24%;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
    }
  }

  .visibleView {
    visibility: visible;
  }

  .sipUserIcon {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 10px;
    top: 10px;
    z-index: 12;

    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }

  .sipCallStatus {
    position: absolute;
    width: 176px;
    height: 148px;
    left: 50%;
    top: 50%;
    margin-left: -88px;
    margin-top: -54px;
    z-index: 12;
    text-align: center;

    img {
      height: 108px;
      width: 108px;
    }

    .sipUserName {
      text-align: center;
      height: 32px;
      line-height: 32px;
      font-size: 16px;
      color: #f0f0f0;
    }
  }

  .sipEndMessage {
    width: 100%;
    text-align: center;
    height: 32px;
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 13;
    margin-top: -16px;
    font-size: 16px;
    color: #e9e9e9;
  }

  .sipControl {
    width: 100%;
    height: 34px;
    position: absolute;
    left: 0;
    bottom: 30px;
    z-index: 14;
    text-align: center;

    .sip-btn:not(:last-child) {
      margin-right: 36px;
    }
    .sip-btn {
      cursor: pointer;
      &-label {
        color: #ffffff;
        padding-top: 6px;
      }
    }
  }
}
</style>
